import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import { CustomState } from "@preferredMedical/Store/CustomState";
import { CustomActions } from "@preferredMedical/Store/Reducers";
import React, { Component } from 'react';
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { css } from "styled-components";

interface Styles {
    consentCheckbox?: CheckboxProps;
}

interface OwnProps {
    consentText: string;
}


interface State {
    styles: Styles,
    consent: boolean;
    consentError: string;
}

const styles: Styles = {
    consentCheckbox: {
        css: css`
            margin-top: 3px;
        `,
    },
}

const mapStateToProps = (state: CustomState) => {
    return {
        checkoutReviewAndSubmitState: state.custom.checkoutReviewAndSubmit,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<CustomState, any, CustomActions>) => {
    return {
        setConsent: (consent: boolean) => dispatch({ type: "Custom/Pages/CheckoutReviewAndSubmit/SetConsent", consent }),
    }
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>& ReturnType<typeof mapDispatchToProps>;

class CheckoutReviewAndSubmitConsent extends Component<Props, State> {
    static instances: CheckoutReviewAndSubmitConsent[] = [];
    constructor(props: Props) {
        super(props);
        this.state = {
            styles,
            consent: false,
            consentError: "",
        }
        this.consentChangeHandler = this.consentChangeHandler.bind(this);
        this.update = this.update.bind(this);
        this.props.setConsent(false);
    }

    static async updateAll() {
        for (const comp of CheckoutReviewAndSubmitConsent.instances) {
            await comp.update();
        }
    }

    componentDidMount() {
        CheckoutReviewAndSubmitConsent.instances.push(this);
    }

    componentWillUnmount() {
        const index = CheckoutReviewAndSubmitConsent.instances.indexOf(this);
        CheckoutReviewAndSubmitConsent.instances.splice(index, 1);
    }

    async consentChangeHandler(event: React.SyntheticEvent, value: boolean) {
        const val = value;
        await this.setState({consent: val});
        await this.setState({consentError: (val ? "" : "You must consent to the terms.")});
        this.props.setConsent(val);
    }

    async update() {
        await this.setState({consentError: (this.state.consent ? "" : "You must consent to the terms.")});
    }

    render() {
        return (
            <div>
                <Checkbox
                    checked={this.state.consent}
                    onChange={this.consentChangeHandler}
                    error={this.state.consentError !== ""}
                    {...this.state.styles.consentCheckbox}
                    >
                    {this.props.consentText}
                </Checkbox>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutReviewAndSubmitConsent);